/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Not_FoundInputs */



/**
* | output |
* | --- |
* | "Nothing answered at this path. Use the base URL from the provider's documentation, usually ending in /v1." |
*
* @param {Private_Models_Hint_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_not_found = /** @type {((inputs?: Private_Models_Hint_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unter diesem Pfad antwortet nichts. Verwenden Sie die Basis-URL aus der Dokumentation des Anbieters, meist mit /v1 am Ende.")
	return /** @type {LocalizedString} */ ("Nothing answered at this path. Use the base URL from the provider's documentation, usually ending in /v1.")
});